import React from 'react';

import {DropdownWithExpressions, DropdownWithExpressionsProps, LikeId} from './dropdownWithExpressions';

export type MultipleChoiceDropdownProps<
  T extends LikeId,
  TAdditionalGroupItems extends unknown[] = [],
> = Omit<DropdownWithExpressionsProps<T, TAdditionalGroupItems>, 'canSelectMultipleItems'>;

export const MultipleChoiceDropdown = <T extends LikeId, TAdditionalGroupItems extends unknown[] = []>(
  props: MultipleChoiceDropdownProps<T, TAdditionalGroupItems>,
) => {
  const {anyLabel, anyIcon, canSelectAnyItem, ...rest} = props;

  if (anyLabel && canSelectAnyItem) {
    return (
      <DropdownWithExpressions
        {...rest}
        canSelectMultipleItems
        canSelectAnyItem
        anyLabel={anyLabel}
        anyIcon={anyIcon}
      />
    );
  }

  return <DropdownWithExpressions {...rest} canSelectMultipleItems />;
};
